export const config = {
  title: "Javi’s Construction INC",
  meta: {
    description:
      "Javi’s Construction INC offers expert remodeling and construction services in Chicago, including kitchens, bathrooms, patios, concrete driveways, windows, siding, fences, and demolition.",
    keywords: [
      "Chicago construction",
      "home remodeling Chicago",
      "kitchen remodeling",
      "bathroom remodeling",
      "concrete patios Chicago"
    ],
    author: "Javi’s Construction INC",
    canonicalUrl: "https://javiconstruction.com/",
  },
  sections: {
    header: { businessName: "Javi’s Construction INC" },
    sectionB: {
      heroTitle: "Javi’s Construction INC",
      heroSubtitle: "Expert Construction & Remodeling in Chicago",
      learnAboutText: "Get Your Free Quote",
      phoneNumber: "3122000322",
      phoneLabel: "(312) 200‑0322",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/2151912551/photo/building-contractor-talking-to-clients-renovating-their-house.jpg?s=612x612&w=0&k=20&c=QhL8-C4dGz4ATIhLTaFYD_tKjHTLAKWZIBsuBW_n-ms=",
      cardData: [
        { title: "Kitchen Remodeling", description: "Custom kitchen renovations." },
        { title: "Bathroom Remodeling", description: "Modern bathroom makeovers." },
        { title: "Patios & Concrete", description: "Driveways, slabs, patios." },
      ],
      description:
        "Javi’s Construction INC delivers quality construction services throughout Chicago—including kitchen and bathroom remodeling, concrete patios, driveways, windows, siding, fences, demolitions, and waste disposal.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "We specialize in remodeling and construction projects from interiors to outdoor concrete work.",
      cards: [
        {
          title: "Kitchen Remodeling",
          description: "Custom cabinets, countertops & layout redesign.",
          imageSrc: "https://media.istockphoto.com/id/1093917944/photo/kitchen-install-progress.jpg?s=612x612&w=0&k=20&c=Ww74u5Qv5FqveCJO6B2CwBixsJc7whjFSJq2HGUP174=",
          imageAlt: "Kitchen Remodeling",
        },
        {
          title: "Bathroom Remodeling",
          description: "Fixture upgrades, tiling, and modern finishes.",
          imageSrc: "https://media.istockphoto.com/id/154954087/photo/master-bathroom-in-midst-of-remodeling.jpg?s=612x612&w=0&k=20&c=CKdxxz4TBHzNXgghURHZ483bmfIN8h8mHo6iMkKzjfk=",
          imageAlt: "Bathroom Remodeling",
        },
        {
          title: "Patios & Concrete",
          description: "Driveways, patios, sidewalk slabs & concrete repairs.",
          imageSrc: "https://media.istockphoto.com/id/1027097284/photo/pergola.jpg?s=612x612&w=0&k=20&c=HRU_2ua5MVvIqE2CFcfSSfZK_jE1XAx426JlUoGUlUA=",
          imageAlt: "Concrete & Patios",
        },
      ],
      otherServicesTitle: "More Offerings",
      otherServicesList: [
        "Window & Siding Installation",
        "Fence Construction",
        "Demolition & Waste Removal",
      ],
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://img1.wsimg.com/isteam/ip/f17dcf30-cf72-47ae-848b-5e5df643486b/javi%20logo-d6a16fb.png/:/rs=h:160,cg:true,m/qt=q:95",
        alt: "Javi’s Construction Team",
      },
      aboutText: [
        "At Javi’s Construction INC, our mission is to deliver high‑quality remodeling and building solutions on time and within budget.",
        "We are dedicated to craftsmanship, clear communication, and exceeding client expectations.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Javi’s Construction Logo",
      businessName: "Javi’s Construction INC",
      contact: {
        phone: "3122000322",
        phoneLabel: "(312) 200‑0322",
        email: "info@bizsolutions.us",
        website: "https://javiconstruction.com/",
        address: "Chicago, IL, USA",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "Chicago, IL, USA",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d189076.1355201684!2d-87.9401015!3d41.8333925!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x880e2c05e3e2e5f1%3A0x3e2c8a42dbf0f6a4!2sChicago%2C%20IL%2C%20USA!5e0!3m2!1sen!2sus!4v1718835000000!5m2!1sen!2sus",
    }
  },
};

export default config;
